<template>
    <!-- Componente principal para el simulador de crédito con las 2 opciones de financiamiento -->
    <div
        id="request-quote"
        class="container pb-10"
    >
        <!-- Contenedor del loader del simulador -->
        <div
            v-show="loadingQuote"
            class="mt-10 bg-light-brown py-8 lg:py-16 px-4 lg:px-20 text-center h-full shadow"
        >
            <!-- Change for loadingQuote -->
            <!-- <div class="lds-dual-ring mx-auto mt-32 lg:mt-48"></div> -->
            <p class="font-medium leading-tight sm:text-lg">Estamos calculando tu financiamiento</p>
            <p class="leading-tight text-sm mt-1 sm:text-base">A continuación te presentamos algunas opciones</p>
            <spinner-loader
                class="mt-8"
                :progress="quotesProgress"
            />
            <!-- <p class="text-light-blue">Calculando...</p> -->
        </div>
        <!-- Contenedor del simulador de crédito -->
        <div
            class="simulator"
            v-show="showSimulator"
        >
            <!-- <div>
                <h1 class="font-medium text-2xl lg:text-3xl mb-3">Solicitar Cotización</h1>
                <p>Aquí podrás solicitar una cotización y simular un financimiento para la compra de tu vehículo.</p>
                <p class="text-sm mt-3 lg:text-right"><span class="text-light-blue">*</span>Campos requeridos</p>
                <div class="line border-solid border-b border-gray3 my-4"></div>
            </div> -->
            <!-- Contenedor para mostrar los datos del modelo seleccionado en el iframe -->
            <div
                v-if="isIframe"
                class="mt-8"
            >
                <h4 class="sm:text-lg lg:text-xl font-medium">Detalles del vehículo</h4>
                <p class="lg:text-lg">Éste es el vehículo que elegiste:</p>
                <div class="flex flex-col space-y-2 md:space-y-0 md:flex-row mt-4 md:justify-between lg:text-lg">

                    <div
                        class="bg-light-brown p-3 xs:p-4 w-full md:w-4/12 xl:w-3/12 leading-none flex flex-col space-y-2 justify-around text-center">
                        <div class="flex flex-col space-y-1 lg:space-y-2">
                            <p class="font-medium">Modelo / Versión</p>
                            <p>{{ `${modelName} ${versionName}` }}</p>
                        </div>
                        <div class="flex flex-col space-y-1 lg:space-y-2">
                            <p class="font-medium">Color Ext. / Int.</p>
                            <p>{{ capFirstLetter(exColorSelected) }} / {{ formatIntColor(intColorSelected) }}</p>
                        </div>
                    </div>
                    <picture class="w-full md:w-4/12 xl:w-3/12">
                        <img
                            :src="modelImage"
                            :alt="`${modelName} ${versionName} ${capFirstLetter(exColorSelected)} / ${capFirstLetter(intColorSelected)}`"
                        >
                    </picture>
                    <div
                        class="bg-light-brown p-3 xs:p-4 w-full md:w-4/12 xl:w-3/12 leading-none flex flex-col space-y-2 justify-around text-center">
                        <div class="flex flex-col space-y-1 lg:space-y-2">
                            <p class="font-medium">Año</p>
                            <p>{{ modelYear }}</p>
                        </div>
                        <div class="flex flex-col space-y-1 lg:space-y-2">
                            <p class="font-medium">Costo del vehículo</p>
                            <p>${{ formatPrice(parseInt(versionPrice)) }}</p>
                        </div>
                    </div>
                    <!-- <div class="bg-light-brown text-center py-4 px-2 lg:p-6 w-full md:w-1/3 h-32 lg:h-48">
                        <p class="font-medium">Marca / Modelo / Versión</p>
                        <p class="mt-3 lg:mt-4">{{`${modelName} ${versionName}`}}</p>
                    </div>
                    <div class="bg-light-brown text-center py-4 px-2 lg:p-6 w-full md:w-1/3 h-32 lg:h-48 lg:mx-5 mt-4 md:mt-0 md:ml-2">
                        <p class="font-medium">Año</p>
                        <p class="mt-3 lg:mt-4">{{modelYear}}</p>
                    </div>
                    <div class="bg-light-brown text-center py-4 px-2 lg:p-6 w-full md:w-1/3 h-32 lg:h-48 mt-4 md:mt-0 md:ml-2">
                        <p class="font-medium">Costo del vehículo</p>
                        <p class="mt-3 lg:mt-4">${{formatPrice(parseInt(versionPrice))}}</p>
                    </div> -->
                </div>
            </div>
            <!-- Contenedor del select de distribuidores para mostrarlo en el iframe siempre que no venga el dato desde el back -->
            <div
                v-if="isIframe && !subData.fromBack"
                class="mt-8"
            >
                <h4 class="text-lg font-medium">Selecciona un distribuidor</h4>
                <subsidiary-select
                    redirect="false"
                    @sub-selected="changeSubData"
                ></subsidiary-select>
            </div>
            <!-- <div class="mt-8">
                <h4 class="text-lg font-medium">2. Selecciona tu estado</h4>
                <select
                    name="city" id="city" class="mt-4 h-8 w-56 pl-1 border border-solid border-light-gray bg-white"
                    v-model.number="state">
                    <option value="0" disabled selected>-Selecciona una opción-</option/>
                    <option v-for="state in states" :key="state.id" :value="state.id">{{state.name}}</option/>
                </select>
            </div> -->
            <!-- <div class="mt-16 text-center">
                <h3 class="font-medium text-lg">¿Quieres calcular el financiamiento de tu automóvil con <a class="text-light-blue underline" href="">BBVA</a> o <a class="text-light-blue underline" href="">CETELEM</a>?</h3>
            </div> -->
            <!-- Contenedor de las opciones para el calculo de las cotizaciones -->
            <div class="mt-10 bg-light-brown py-8 lg:py-16 px-4 lg:px-20">
                <h4 class="leading-tight text-center font-medium sm:text-lg lg:text-xl">Ingresa el enganche y el plazo
                    para tu auto deseadoz</h4>
                <p class="text-center text-sm leading-tight mt-2 sm:text-base">La cantidad debe ser menor a
                    ${{ formatPrice(maxDownpayment) }} y mínimo de ${{ formatPrice(minDownpayment) }}</p>
                <!-- <div class="flex justify-center items-center mt-4 mb-6">
                    <div class="bg-brown rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium text-white">1</div>
                    <div class="font-medium -mt-2">....</div>
                    <div class="bg-light-blue rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium text-white">2</div>
                </div> -->
                <div class="downpayment mt-4 flex items-center justify-center">
                    <p class="text-sm font-medium mr-2 lg:mr-4">Enganche:</p>
                    <currency-input-f2 v-model="downpayment" />
                </div>
                <div class="instalments mt-6">
                    <!-- <p class="text-sm font-medium">Plazos:</p> -->
                    <!-- Cetelem Activo -->
                    <!-- :disabled="!(!this.loadingCetelemQuotation && !this.loadingBbvaQuotation)" -->

                    <range-slider-f2
                        :value="rangeInstalment"
                        @input="onRangeInstChange($event)"
                        :disabled="this.loadingBbvaQuotation"
                    />
                    <div class="text-center mt-10 lg:mt-12">
                        <p class="text-sm leading-tight text-light-blue mb-6 sm:text-base lg:mb-8">Mueve para indicar
                            las mensualidades que mejor te convengan</p>
                        <button
                            class="w-full sm:w-40 text-center bg-dark-blue text-white text-sm py-2 mx-auto"
                            :class="{ 'bg-opacity-50': loadingButton, 'cursor-default': loadingButton }"
                            :disabled="loadingButton"
                            @click="calculateQuotes()"
                        >
                            {{ loadingButton ? 'Calculando...' : 'Calcular' }}
                        </button>
                        <p class="text-sm leading-tight text-center mt-10">
                            La información aquí presentada es de carácter informativo y no constituye el precio, plazos
                            ni condiciones finales aplicables al crédito.<br>Para validar la información final, será
                            contactado por el Distribuidor Autorizado Hyundai seleccionado.
                        </p>
                    </div>
                </div>
            </div>
            <!-- Contenedor para mostrar las cotizaciones -->
            <div
                class="quotations mt-10"
                id="quotations"
                v-show="showQuotations"
            >
                <!-- change for showQuotations -->
                <!-- <div class="line border-solid border-b border-gray3 my-4"></div> -->
                <h3 class="font-medium text-center mt-4 lg:mt-8 leading-snug lg:text-2xl">Resumen de tu simulación</h3>
                <!-- <div class="lg:hidden">
                    <p class="font-medium text-center">1 de 2</p>
                    <div
                        id="quots-dots"
                        class="flex space-x-1 justify-center mt-2"
                    >
                        <div
                            id="dot-1"
                            class="h-2 w-2 rounded-full bg-dark-blue"
                        ></div>
                        <div
                            id="dot-2"
                            class="h-2 w-2 rounded-full bg-light-gray"
                        ></div>
                    </div>
                </div> -->

                <div
                    id="quots"
                    class="overflow-x-scroll overscroll-x-contain flex space-x-6 xl:space-x-8"
                    style="overscroll-behaivor-x: contain; scroll-snap-type: x proximity;"
                >
                    <!-- Contenedor de la cotización de BBVA -->
                    <div
                        id="bbva-quot"
                        class="w-64 min-w-full lg:min-w-0 lg:w-full mt-10"
                        style="scroll-snap-align: center;"
                    >
                        <bbva-quotation-f2
                            v-show="showBbvaQuotation"
                            :instalments="instalments"
                            :inst-selected="instToBbva"
                            :bbva-quotation="bbvaQuotation"
                            :version-id="versionId"
                            :click-to-buy="clickToBuy"
                            :bbva-app-id="bbvaAppId"
                            :subsidiary="subsidiary"
                            :is-iframe="isIframe"
                            :data-table="dataForTable"
                            @bad-instalment="badInstalment('bbva')"
                            @charge-bbva-form="chargeBbvaForm"
                            @charge-bbva-form-f2="chargeBbvaFormF2"
                        />
                        <div
                            class="text-center mt-10 text-light-blue font-medium"
                            v-if="loadingBbvaQuotation"
                        >Calculando con BBVA...</div>
                        <div
                            class="text-center mt-10 w-4/6 mx-auto text-light-blue"
                            v-else-if="bbvaQuotErrs.length === 12"
                        >
                            <!-- <p class="font-medium">Hubo un problema en tu Simulación con BBVA, consulta con CETELEM</p> -->
                            <p class="font-medium">Hubo un problema en tu Simulación con BBVA</p>
                            <i class="fa-solid fa-arrow-right text-2xl mt-2"></i>
                        </div>
                    </div>
                    <!-- Contenedor de la cotización de Cetelem -->
                    <!-- <div
                        id="cetelem-quot"
                        class="w-64 min-w-full lg:min-w-0 lg:w-1/2 mt-10 collapse"
                        style="scroll-snap-align: center;"
                        > -->
                        <!-- change for showCetelemQuotation -->
                        <!-- <cetelem-quotation-f2
                            v-show="false"
                            :instalments="instalments"
                            :inst-selected="instToCetelem"
                            :cetelem-quotation="cetelemQuotation"
                            :version-id="versionId"
                            :subsidiary="subsidiary"
                            :is-iframe="isIframe"
                            @bad-instalment="badInstalment('cetelem')"
                            @charge-cetelem-form="chargeCetelemForm"
                        /> -->
                        <!-- <div
                            class="text-center mt-10 font-medium"
                            v-if="loadingCetelemQuotation"
                        >Calculando con CETELEM...
                        </div> -->
                        <!-- <div
                            class="mt-10 w-4/6 mx-auto text-center"
                            v-else-if="Object.keys(cetelemQuotation).length === 0"
                            > -->
                            <!-- change for Object.keys(cetelemQuotation).length === 0 -->
                            <!-- <p class="font-medium">Hubo un problema en tu Simulación con CETELEM, consulta con BBVA</p>
                            <i class="fa-solid fa-arrow-left text-2xl mt-2"></i>
                        </div> -->
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <!-- Componente del formulario de BBVA para la descarga de la tabla de amortización -->
        <bbva-form
            v-show="showBbvaForm"
            :show-bbva-form="showBbvaForm"
            :subsidiary="subsidiary"
            :sub-name="subName"
            :model-name="modelName"
            :version-id="versionId"
            :version-name="versionName"
            :version-price="versionPrice"
            :model-year="modelYear"
            :bbva-app-id="bbvaAppId"
            :term="instalments[instSelected]"
            :pago-mensual="bbvaQuotData.pagoMensual"
            :monto-total="bbvaQuotData.montoTotal"
            :total-pagar="bbvaQuotData.totalAPagar"
            :enganche="downpayment"
            :seguro="bbvaQuotData.seguro"
            :app-env="appEnv"
            :is-iframe="isIframe"
            @back-to-simulator="backToSimulator"
        >
        </bbva-form>
        <!-- Componente del formulario de pre autorización de crédito con BBVA -->
        <bbva-form-f2
            v-show="showBbvaFormF2"
            :data-for-f2="dataForF2"
            :app-env="appEnv"
            :is-iframe="isIframe"
            @param-changed="resetSimulator"
            @back-to-simulator="backToSimulator"
        ></bbva-form-f2>
        <!-- Componente del formulario de Cetelem para la descarga de la tabla de amortización -->
        <!-- <cetelem-form
            v-show="showCetelemForm"
            :show-cetelem-form="showCetelemForm"
            :subsidiary="subsidiary"
            :sub-name="subName"
            :model-name="modelName"
            :version-name="versionName"
            :model-year="modelYear"
            :term="instalments[instSelected]"
            :pago-mensual="cetelemQuotData.pagoMensual"
            :monto-total="cetelemQuotData.montoTotal"
            :total-pagar="cetelemQuotData.totalAPagar"
            :id-aseguradora="cetelemQuotData.idAseguradora"
            :id-plan="cetelemQuotData.idPlan"
            :enganche="downpayment"
            :cetelem-data="cetelemData"
            :app-env="appEnv"
            :is-iframe="isIframe"
            @back-to-simulator="backToSimulator"
        > 
        </cetelem-form> -->
    </div>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import Swal from "sweetalert2";
import { capFirstLetter, formatIntColor } from "./helpers/helpers_functions";
export default {
    components: {
        Splide,
        SplideSlide,
    },
    props: [
        "modelId",
        "versionId",
        "modelName",
        "versionName",
        "modelYear",
        "versionPrice",
        "clickToBuy",
        "bbvaAppId",
        "subData",
        "states",
        "appEnv",
        "isIframe",
        "exColorSelected",
        "intColorSelected",
        "modelImage",
        "mainEmail",
    ],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            // Variable para almacenar los plazos disponibles
            instalments: [12, 24, 36, 48, 60, 72],
            // Variable para almacenar el índice del plazo seleccionado
            instSelected: 0,
            // Variable para almacenar el plazo seleccionado
            // para la cotización de cetelem
            instToCetelem: null,
            // Variable para almacenar el plazo seleccionado
            // para la cotización de BBVA
            instToBbva: null,
            // Variable para almacenar el engache
            downpayment: 0,
            // Variable para almacenar el distribuidor seleccionado
            subsidiary: this.subData.caption_text,
            // Variable para almacenar el nombre del distribuidor
            subName: this.subData.name,
            // Variable para almacenar el estado
            state: this.subData.geo_state_id,
            // Variable para almacenar el plazo seleccionado desde el slider
            rangeInstalment: "12",
            // Variable para alamcenar los datos de la simulación con BBVA
            bbvaSimulation: {
                insu: [],
                noInsu: [],
            },
            // Variable para almacenar los datos de la simulación con BBVA
            // una vez que se tiene la respuesta de todos los plazos
            bbvaQuotation: {
                insu: [],
                noInsu: [],
            },
            // Variable para almacenar la cantidad de respuestas
            // que se han recibido para las cotizaciones
            numRespQuotes: 0,
            // Variable para almacenar los datos de la simulación con Cetelem
            cetelemQuotation: {},
            // Variable para determinar si mostrar el simulador
            showSimulator: true,
            // Variable para determinar si mostrar las cotizaciones
            showQuotations: false,
            // Variable para determinar si mostrar la cotización de BBVA
            showBbvaQuotation: false,
            // Variable para determinar si mostrar la cotización de Cetelem
            showCetelemQuotation: false,
            // Variable para determinar si están cargando los cotizadores
            loadingQuote: false,
            // Variable para determinar si está cargando la cotización de BBVA
            loadingBbvaQuotation: false,
            // Variable para determinar si está cargando la cotización de Cetelem
            loadingCetelemQuotation: false,
            // Variable para determinar si recalcular las cotizaciones
            recalcQuote: true,
            // Variable para determinar si el plazo seleccionado
            // no está disponible para Cetelem
            badCetelemInst: false,
            // Variable para determinar si el plazo seleccionado
            // no está disponible para BBVA
            badBbvaInst: false,
            // Variable para almacenar los errores de los plazos
            // de la cotización de BBVA
            bbvaQuotErrs: [],
            // Variable para determinar si mostrar el formulario
            // de BBVA para la descarga de la tabla de amortización
            showBbvaForm: false,
            // Variable para determinar si mostrar el formulario
            // de BBVA para la pre autorización de crédito
            showBbvaFormF2: false,
            // Variable para determinar si mostrar el formulario
            // de Cetelem para la descarga de la tabla de amortización
            showCetelemForm: false,
            // Variable para almacenar los datos de la cotización
            // de BBVA para el formulario para la descarga de la
            // tabla de amortización
            bbvaQuotData: {},
            // Variable para almacenar los datos de la cotización
            // de Cetelem para el formulario para la descarga de la
            // tabla de amortización
            cetelemQuotData: {},
            // Variable para almacenar los datos adicionales
            // de la cotización con Cetelem
            cetelemData: {},
            // Variable para almacenar la opción seleccionada
            // para incluir el seguro en la cotización de BBVA
            casualtyInsurance: "insu",
            // Variable para determinar si cancelar el cálculo
            // de la cotización con BBVA
            cancelBbvaQuot: false,
            // Variable para determinar si cancelar el cálculo
            // de la cotización con Cetelem
            cancelCetelemQuot: false,
            // Función importada para capitalizar la pirmer letra
            // de un string
            capFirstLetter,
            // Función importada para dar formato al
            // string de color interior
            formatIntColor,
        };
    },
    watch: {
        // Observa la variable del enganche para reestablecer
        // el cotizador en caso de que cambie
        downpayment: function (val) {
            if (this.showQuotations) {
                this.showQuotations = false;
                this.showBbvaQuotation = false;
                this.showCetelemQuotation = false;
            }
            this.recalcQuote = true;
        },
        // Observa la variable instSelected para ocultar los
        // cotizadores en caso de que cambie el plazo
        instSelected: function (val) {
            if (this.showQuotations) {
                this.showQuotations = false;
            }
        },
        // Observa la variable showQuotations para hacer un
        // scroll a la altura de los cotizadores
        showQuotations: function (val) {
            if (val) {
                this.$nextTick(function () {
                    this.numRespQuotes = 0;
                    let quotsTop = document
                        .getElementById("quotations")
                        .getBoundingClientRect().top;
                    $("html, body").animate(
                        {
                            scrollTop: quotsTop + $(window).scrollTop() - 10,
                            // scrollTop: bbvaTop - 40 - 68
                        },
                        1000
                    );
                });
            } else {
                // hide chart
            }
        },
    },
    methods: {
        // Función para dar formato a precios
        formatPrice(price, n, x) {
            let re =
                "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
            return parseInt(price)
                .toFixed(Math.max(0, ~~n))
                .replace(new RegExp(re, "g"), "$&,");
        },
        // Función para determinar el plazo seleccionado
        // cuando se mueve el slider del plazo
        onRangeInstChange(e) {
            this.rangeInstalment = e;
            let index = this.instalments.indexOf(
                parseInt(this.rangeInstalment)
            );
            this.instSelected = index;
        },
        // Función para ocultar las cotizadores si alguna falla
        // o si no está disponible el plazo seleccionado o si
        // fallan ambas mostrar un mensaje de error
        badInstalment(provider) {
            if (provider === "cetelem") {
                this.badCetelemInst = true;
                this.showCetelemQuotation = false;
                // this.instToCetelem = null
            }

            if (provider === "bbva") {
                this.badBbvaInst = true;
                this.showBbvaQuotation = false;
                // this.instToBbva = null
            }

            if (this.badCetelemInst && this.badBbvaInst) {
                this.showQuotations = false;
                // this.showCetelemQuotation = false
                // this.instToQuote = 0
                // this.changeInstalment(0)
                // this.recalcQuote = true
                this.showSwalError(
                    "Plazo no disponible",
                    "<p>El plazo seleccionado no está disponible, selecciona otro para continuar.</p>"
                );
            } else if (this.badCetelemInst) {
                if (
                    !this.loadingBbvaQuotation &&
                    this.bbvaQuotErrs.length === 12
                ) {
                    this.showQuotations = false;
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible, selecciona otro para continuar.</p>"
                    );
                } else {
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible para CETELEM, consulta con BBVA.</p>"
                    );
                }
            } else if (this.badBbvaInst) {
                if (
                    !this.loadingCetelemQuotation &&
                    $.isEmptyObject(this.cetelemQuotation)
                ) {
                    this.showQuotations = false;
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible, selecciona otro para continuar.</p>"
                    );
                } else {
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible para BBVA, consulta con CETELEM.</p>"
                    );
                }
            }
        },
        // Función para mostrar un mensaje de error
        showSwalError(title, msg, reload = false) {
            Swal.fire({
                icon: "error",
                title: `<h3 class="text-2xl leading-tight font-medium">${title}</h3>`,
                html: msg,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton:
                        "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (reload) {
                    window.location.reload();
                }
            });
        },
        // Función para ocultar las cotizaciones y establecer
        // los datos del distribuidor cuando cambia el select
        changeSubData(sub) {
            console.log(sub);
            if (this.showQuotations) {
                this.showQuotations = false;
            }
            this.recalcQuote = true;
            this.subsidiary = sub.caption_text;
            this.subName = sub.name;
            this.state = sub.geo_state_id;
        },
        // Función para calcular la cotización de BBVA
        calculateBbvaQuote() {

            this.bbvaQuotErrs = []; // Variable para guardar los errores que arroje el API
            // Envía una petición por cada term con seguro
            axios
                .post(`${this.url}/bbva/calcular-cotizacion`, {
                    pt_id: this.versionId,
                    enganche: this.downpayment,
                    year: this.modelYear,
                    plan_term: this.instalments[instSelected],
                    seguro: true,
                })
                .then((resp) => {
                    console.log(res);
                    if (!this.showCetelemForm && !this.cancelBbvaQuot) {
                        console.log(
                            "/bbva/calcular-cotizacion/insu/" + term,
                            resp
                        );
                        let { data } = resp;
                        if (data.success) {
                            this.bbvaSimulation.insu[i] =
                                data.data.installments[0];
                            this.bbvaSimulation.insu[i].bbvaQuotationId =
                                data.bbva_quotation_id;
                            // this.bbvaSimulation.insu[i].success = true
                        } else {
                            // this.bbvaSimulation.insu[i] = { success: false }
                            this.bbvaSimulation.insu[i] = false;
                            this.bbvaQuotErrs.push(data.errors);
                        }
                        this.sumQuoteResp();
                        this.showBbvaResp();
                    }
                });
            axios
                .post(`${this.url}/bbva/calcular-cotizacion`, {
                    pt_id: this.versionId,
                    enganche: this.downpayment,
                    year: this.modelYear,
                    plan_term: this.instalments[instSelected],
                    seguro: false,
                })
                .then((resp) => {
                    if (!this.showCetelemForm && !this.cancelBbvaQuot) {
                        console.log(
                            "/bbva/calcular-cotizacion/noInsu/" + term,
                            resp
                        );
                        let { data } = resp;
                        if (data.success) {
                            this.bbvaSimulation.noInsu[i] =
                                data.data.installments[0];
                            this.bbvaSimulation.noInsu[i].bbvaQuotationId =
                                data.bbva_quotation_id;
                            // this.bbvaSimulation.noInsu[i].success = true
                        } else {
                            // this.bbvaSimulation.noInsu[i] = { success: false }
                            this.bbvaSimulation.noInsu[i] = false;
                            this.bbvaQuotErrs.push(data.errors);
                        }
                        numNoInsuResp++;
                        this.sumQuoteResp();
                        this.showBbvaResp();
                    }
                });
        },
        // Función para mostrar la cotización de BBVA
        // en caso de que no hayan fallado todos los plazos
        // o mostrar un mensaje de error en caso contrario
        showBbvaResp() {
            if (this.bbvaQuotErrs.length < 12) {


                this.bbvaQuotation.insu = this.bbvaSimulation.insu;
                this.bbvaQuotation.noInsu = this.bbvaSimulation.noInsu;

                this.instToBbva = this.instSelected;
                this.showBbvaQuotation = true;
                this.loadingQuote = false;
                this.showSimulator = true;
                this.showQuotations = true;
                this.recalcQuote = false;
                this.loadingBbvaQuotation = false;
            } else {
                this.loadingBbvaQuotation = false;

                // if (
                //     this.loadingCetelemQuotation &&
                //     $.isEmptyObject(this.cetelemQuotation)
                // ) {
                    this.showSwalError(
                        "Hubo un problema al procesar tu solicitud",
                        "Por el momento, el vehículo que seleccionaste no está disponible. Elige otro e inténtalo de nuevo.",
                        true
                    );
                // }
                // else {
                //     this.loadingQuote = false
                //     this.showSimulator = true
                //     this.showQuotations = true
                //     this.recalcQuote = false
                //     this.showSwalError('Hubo un problema en tu Simulación con BBVA Consumer Finance', "Consulta con CETELEM")
                // }
            }
        },
        // Función para calcular la cotización de cetelem
        calculateCetelemQuote() {
            axios
                .post(`${this.url}/cetelem/calcular-cotizacion`, {
                    pt_id: this.versionId,
                    pdvIdMarca: this.subsidiary,
                    estado: parseInt(this.state),
                    enganche: this.downpayment,
                })
                .then((resp) => {
                    console.log("/cetelem/calcular-cotizacion", resp);
                    if (!this.cancelCetelemQuot) {
                        if (
                            resp.data.success &&
                            resp.data.data.quotation.planes[0].termsXAseguradora
                                .length > 0
                        ) {
                            this.cetelemQuotation = resp.data.data.quotation;
                            this.cetelemData = resp.data.cetelemData;
                            this.instToCetelem = this.instSelected;
                            this.recalcQuote = false;
                            this.loadingCetelemQuotation = false;
                            this.loadingQuote = false;
                            this.showCetelemQuotation = true;
                            if (!this.showBbvaForm && !this.showBbvaFormF2) {
                                this.showSimulator = true;
                                this.showQuotations = true;
                            }
                        } else {
                            this.loadingCetelemQuotation = false;
                            if (
                                !this.loadingBbvaQuotation &&
                                this.bbvaQuotErrs.length === 12
                            ) {
                                this.loadingQuote = false;
                                this.recalcQuote = true;
                                this.showSwalError(
                                    "Hubo un problema al procesar tu solicitud",
                                    "Por el momento, el vehículo que seleccionaste no está disponible. Elige otro e inténtalo de nuevo.",
                                    true
                                );
                            }
                            // else {
                            //     this.loadingQuote = false
                            //     this.showSimulator = true
                            //     this.showQuotations = true
                            //     this.recalcQuote = false
                            //     this.showSwalError('Hubo un problema en tu Simulación con CETELEM', "Consulta con BBVA")
                            // }
                        }
                        this.sumQuoteResp();
                    }
                })
                .catch((error) => {
                    this.loadingQuote = false;
                    if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                        let errors = error.response.data.errors;
                        let message = "";
                        for (let error in errors) {
                            message += `<p>${errors[error]}</p>`;
                        }
                        if (
                            !this.loadingBbvaQuotation &&
                            this.bbvaQuotErrs.length === 12
                        ) {
                            this.showSwalError(
                                "Hubo un problema al procesar tu solicitud",
                                "<p>Inténtalo de nuevo más tarde.</p>",
                                true
                            );
                            this.loadingQuote = false;
                            this.showQuotations = false;
                            this.showCetelemQuotation = false;
                            this.loadingCetelemQuotation = false;
                            this.recalcQuote = true;
                        } else {
                            this.loadingCetelemQuotation = false;
                        }
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log("Error", error.message);
                    }
                });
        },
        // Función para llamar a las funciones para calcular
        // las cotizaciones cuando se cumplen las condiciones requeridas
        calculateQuotes() {
            // Hace la llamada para los simuladores de ambas calculadoras
            // Si el estado no es el default y el enganche es mayor al mínimo hace la petición
            if (this.isSubData && this.isDownpaymentCorrect) {
                dataLayer.push({
                    event: "calcular_financiamiento",
                    modelo: this.modelName,
                    version: this.versionName,
                    year_model: this.modelYear,
                    distribuidor: this.subName,
                    estado: this.states.find(
                        (state) => state.id === parseInt(this.state)
                    ).name,
                    enganche: this.downpayment, // número
                    plazo: this.instalments[this.instSelected] + " meses",
                });

                if (this.recalcQuote) {
                    this.showSimulator = false;
                    this.loadingQuote = true;
                    this.showBbvaQuotation = false;
                    this.loadingBbvaQuotation = true;
                    this.showCetelemQuotation = false;
                    this.loadingCetelemQuotation = true;
                    this.cancelBbvaQuot = false;
                    this.cancelCetelemQuot = false;

                    this.calculateBbvaQuote();
                    // this.calculateCetelemQuote();
                } else {
                    this.instToCetelem = this.instSelected;
                    this.instToBbva = this.instSelected;
                    this.loadingQuote = false;
                    this.showSimulator = true;
                    this.showQuotations = true;
                    this.showCetelemQuotation = !$.isEmptyObject(
                        this.cetelemQuotation
                    )
                        ? true
                        : false;
                    this.showBbvaQuotation =
                        this.bbvaQuotErrs.length < 12 ? true : false;
                    this.loadingBbvaQuotation = false;
                    this.loadingCetelemQuotation = false;
                }
            } else {
                let message = "";
                if (!this.isSubData) {
                    message += "<p>Debes seleccionar un distribuidor</p>";
                }
                if (!this.isDownpaymentCorrect) {
                    if (this.downpayment < this.minDownpayment)
                        message += `<p>El enganche debe ser mínimo de $${this.formatPrice(
                            this.minDownpayment
                        )}</p>`;
                    else if (this.downpayment > this.maxDownpayment)
                        message += `<p>El enganche debe ser menor a $${this.formatPrice(
                            this.maxDownpayment
                        )}</p>`;
                }
                this.showSwalError("Datos requeridos", message);
            }
        },
        // Función para cargar el formulario de BBVA para
        // descargar la tabla de amortización
        chargeBbvaForm(quotData) {
            this.bbvaQuotData = { ...quotData };
            this.showSimulator = false;
            this.showBbvaForm = true;
            this.$nextTick(function () {
                let reqTop = document
                    .getElementById("bbva-form")
                    .getBoundingClientRect().top;
                $("html, body").animate(
                    {
                        scrollTop: reqTop + $(window).scrollTop() - 20,
                    },
                    1000
                );
            });
        },
        // Función para cargar el formulario de la
        // pre autorización de crédito
        chargeBbvaFormF2(quotData) {
            this.bbvaQuotData = { ...quotData };
            this.showSimulator = false;
            this.showBbvaFormF2 = true;
            this.$nextTick(function () {
                let reqTop = document
                    .getElementById("bbva-form-f2")
                    .getBoundingClientRect().top;
                $("html, body").animate(
                    {
                        scrollTop: reqTop + $(window).scrollTop() - 20,
                    },
                    1000
                );
            });
        },
        // Función para regresar al simulador y hacer scroll
        // a la altura del mismo
        backToSimulator() {
            this.showCetelemForm = false;
            this.showBbvaForm = false;
            this.showBbvaFormF2 = false;
            this.showSimulator = true;
            this.$nextTick(function () {
                let reqTop = document
                    .getElementById("quotations")
                    .getBoundingClientRect().top;
                $("html, body").animate(
                    {
                        scrollTop: reqTop + $(window).scrollTop() - 20,
                    },
                    1000
                );
            });
        },
        // Función para reestablecer el simulador de crédito
        resetSimulator() {
            this.cancelCetelemQuot = true;
            this.loadingQuote = false;
            this.loadingCetelemQuotation = false;
            this.showBbvaFormF2 = false;
            this.showQuotations = false;
            this.showBbvaQuotation = false;
            this.showCetelemQuotation = false;
            this.recalcQuote = true;
            this.showSimulator = true;
        },
        // Función para cargar el formulario de cetlem
        // para descargar la tabla de amortización
        chargeCetelemForm(quotData) {
            this.cetelemQuotData = quotData;
            this.showSimulator = false;
            this.showCetelemForm = true;
            this.$nextTick(function () {
                let reqTop = document
                    .getElementById("cetelem-form")
                    .getBoundingClientRect().top;
                $("html, body").animate(
                    {
                        scrollTop: reqTop + $(window).scrollTop() - 20,
                    },
                    1000
                );
            });
        },
        // Función para sumar 1 a las respuestas de las cotizaciones
        // para determinar el porcenaje de avance
        sumQuoteResp() {
            this.numRespQuotes++;
        },
    },
    computed: {
        // Retorna el engange mínimo requerido
        minDownpayment() {
            let minDownpayment = Math.round(
                parseFloat(this.versionPrice) * 0.2,
                2
            );
            this.downpayment = minDownpayment;
            return minDownpayment;
        },
        // Retorna el engache máximo aceptado
        maxDownpayment() {
            return parseFloat(this.versionPrice) - 30000;
        },
        // Retorna un valor booleano para determinar si
        // el engance cumple con el mínimo y máximo requerido
        isDownpaymentCorrect() {
            return (
                this.downpayment >= this.minDownpayment &&
                this.downpayment <= this.maxDownpayment
            );
        },
        // Retorna un valor booleano para determinar si se ha
        // seleccionado un distribuidor
        isSubData() {
            return this.subsidiary && this.subName && this.state;
        },
        // Retorna un varlo booleano para determinar si están
        // cargando los cotizadores y mostrar el menaje en el botón
        loadingButton() {
            // return (this.showBbvaQuotation && this.showCetelemQuotation) || !this.loadingQuote ? false : true
            // Activar esto cuando esté activo Cetelem
            // return this.loadingBbvaQuotation || this.loadingCetelemQuotation;
            return this.loadingBbvaQuotation;

        },
        // Retorna el progreso del cálculo de los cotizadores
        quotesProgress() {
            return ((this.numRespQuotes * 100) / 13).toFixed(0);
        },
        // Retorna la información requerida para hacer
        // la tabla de amortización para BBVA
        dataForTable() {
            return {
                subName: this.subName,
                modelName: this.modelName,
                versionId: this.versionId,
                versionName: this.versionName,
                versionPrice: this.versionPrice,
                modelYear: this.modelYear,
                term: this.instalments[this.instSelected],
                downpayment: this.downpayment,
            };
        },
        // Retorna la información requerida para la
        // pre autorización de crédito
        dataForF2() {
            return {
                subsidiary: this.subsidiary,
                versionId: this.versionId,
                modelYear: this.modelYear,
                versionPrice: this.versionPrice,
                downpayment: this.downpayment,
                term: this.instalments[this.instSelected],
                exColorSelected: this.exColorSelected,
                intColorSelected: this.intColorSelected,
                casualtyInsurance: this.casualtyInsurance,
                bbvaQuotationId: this.showBbvaQuotation
                    ? this.bbvaSimulation[this.casualtyInsurance][
                        this.instSelected
                    ].bbvaQuotationId
                    : null,
                mainEmail: this.mainEmail,
                webpage: this.subData.webpage,
                pagoMensual: this.bbvaQuotData.pagoMensual,
                montoTotal: this.bbvaQuotData.montoTotal,
                totalAPagar: this.bbvaQuotData.totalAPagar,
                quotId: this.bbvaQuotData.quotId,
                modelName: this.modelName,
                versionName: this.versionName,
                subName: this.subName,
            };
        },
    },
    mounted() {
        // Code to animate the dots of simulations
        $("#quots").scroll(function () {
            let simulatorLeft = $(".simulator").position().left;
            let bbvaQuotLeft = $("#bbva-quot").position().left;
            let cetelemQuotLeft = $("#cetelem-quot").position().left;
            // console.log(simulatorLeft, bbvaQuotLeft, cetelemQuotLeft);
            if (simulatorLeft - 100 < bbvaQuotLeft) {
                $("#quots-dots #dot-1").removeClass("bg-light-gray");
                $("#quots-dots #dot-1").addClass("bg-dark-blue");
                $("#quots-dots #dot-2").removeClass("bg-dark-blue");
                $("#quots-dots #dot-2").addClass("bg-light-gray");
            } else if (simulatorLeft + 70 > cetelemQuotLeft) {
                $("#quots-dots #dot-1").removeClass("bg-dark-blue");
                $("#quots-dots #dot-1").addClass("bg-light-gray");
                $("#quots-dots #dot-2").removeClass("bg-light-gray");
                $("#quots-dots #dot-2").addClass("bg-dark-blue");
            }
        });
        // when include insurace change in BbvaQuotationF2
        // change the value of casualtyInsurance for dataForF2
        this.$eventBus.$on("includeInsuranceChanged", (val) => {
            this.casualtyInsurance = val;
        });
    },
};
</script>

<style lang="scss">

</style>